import React, {useState, useEffect, useMemo} from "react";
import TestContentSelect from "./TestContentSelect";
import {Form, Select} from "antd";
import {SELECT_LEVELS} from "@common/SyllabusTopicConceptSelect";
import {getUserSkillsByConcept} from "../axiosRequests/axiosRequests";
import {isObjectEmpty} from "@common/utilityFunctions";

export const DiagnosticTabType = {
    CURRICULUM: {value:'CURRICULUM', display:'Curriculum', skillLabel:'Mathematical skills'},
    TEXT: {value:'TEXT', display:'Text',skillLabel:'Skills'},
    NONE: {value: null, display:'None',skillLabel:''}
}

const DiagnosticTestContentSelect = props => {
    const {
        form,
        onChange,
        popupMatchSelectWidth= false,
        searchSkillData,
        diagnosticTabType = DiagnosticTabType.NONE
    } = props;


    const [skillOptionsList, setSkillOptionsList] = useState([]),
        [contentSelectData, setContentSelectData] = useState({}),
        [lastAppliedSearchData, setLastAppliedSearchData] = useState(null),
        [skillLoading, setSkillLoading] = useState(false);


    const diagnosticSelectLevel = SELECT_LEVELS.CONCEPT,
        diagnosticDefaultLevel = SELECT_LEVELS.SYLLABUS;

    useEffect(() => {
        const currentConceptId = contentSelectData.conceptId;

        if (currentConceptId != null) {
            if (currentConceptId === 0) {
                form.setFieldValue('skillIds',[]);
                setSkillOptionsList([]);
                onChange?.();
            } else {
                getUserSkillsByConcept(currentConceptId).then(data => {
                    setSkillOptionsList(data);
                    if (currentConceptId !== searchSkillData.conceptId) {
                        form.setFieldValue('skillIds', []);
                        setLastAppliedSearchData(null); // Clear the flag, too.
                    }
                    onChange?.();
                });
            }
        }
    }, [contentSelectData.conceptId]);

    useEffect(() => {
        const currentConceptId = contentSelectData.conceptId;

        if (skillOptionsList.length > 0 && searchSkillData.hasOwnProperty('skillIds')) {
            const searchSkillIds = searchSkillData.skillIds;
            const isTargetConcept = currentConceptId === searchSkillData.conceptId;
            const isNewProgrammaticData = lastAppliedSearchData !== searchSkillData;

            if (isTargetConcept && isNewProgrammaticData) {
                form.setFieldValue('skillIds', searchSkillIds);
                setLastAppliedSearchData(searchSkillData); // Mark this specific object as applied
                onChange?.();
            }
        }
    }, [skillOptionsList, searchSkillData]); // Depends on new data AND options being ready

    const updateSkills = ()=>{
        onChange?.();
    }

    const handleTestContentSelectChange = (value)=>{
        if(value && value.hasOwnProperty('conceptId')) {
            setContentSelectData({conceptId:value.conceptId});
        }else{
            onChange?.();
        }
    }

    const ContentSelect = useMemo(()=>{
        return (
            <TestContentSelect
                form={form}
                searchSkillData={searchSkillData}
                useStrands={diagnosticTabType.value === DiagnosticTabType.CURRICULUM.value}
                axiosProps={{forDiagnostics: true, hasCurriculumLink:true, hasQuestions:true, forTests:true }}
                onChange={handleTestContentSelectChange}
                selectLevel={diagnosticSelectLevel}
                defaultLevel={diagnosticDefaultLevel}
                diagnosticTabType={diagnosticTabType}
                handleSetSkillLoading={(val)=> {setSkillLoading(val)}}
            />
        );
    },[searchSkillData, diagnosticTabType.value]);

    return (
        <>
            {DiagnosticTabType.NONE.value === diagnosticTabType.value && <div>Message for developer, you need to add a diagnosticTabType that is not {DiagnosticTabType.NONE.display}</div>}
            {ContentSelect}
            <Form.Item
                label={diagnosticTabType.skillLabel + (skillOptionsList.length > 0 ?` (${skillOptionsList.length})`:'')}
                name="skillIds"
            >
                <Select
                    loading={skillLoading}
                    popupMatchSelectWidth={popupMatchSelectWidth}
                    onChange={updateSkills}
                    virtual={false}
                    showSearch={false}
                    mode={'multiple'}
                    maxTagCount={1}
                    disabled={skillOptionsList.length === 0}
                    aria-disabled={skillOptionsList.length === 0}
                >
                    {skillOptionsList?.map(skill => (
                        <Select.Option key={skill.skillId} value={skill.skillId}>{skill.name}</Select.Option>
                    ))}
                </Select>
            </Form.Item>
        </>
    )
}

export default DiagnosticTestContentSelect;